<template>
  <CDialog v-model="isOpen">
    <header class="mrgb+">
      <h3 class="title">
        {{ $t('courseConnection.activateStationDialog.title') }}
      </h3>
      <h5>
        {{ $t('courseConnection.activateStationDialog.description') }}
      </h5>
      <div class="info-container">
        <Icon id="alert-circle-outline" class="icon" a></Icon>
        <p>{{ $t('courseConnection.activateStationDialog.warning') }}</p>
      </div>
    </header>
    <main class="dialog-body">
      <Form @passed="submit">
        <Select
          v-model="station"
          :options="options"
          label="name"
          autofocus
        ></Select>
        <ListInline size="small" class="flex justify-content-between mrgt+">
          <li>
            <Btn variant="outline" @click="isOpen = false">
              {{ $t('common.cancel') }}
            </Btn>
          </li>
          <li>
            <Btn
              data-cy="save-button"
              type="submit"
              :disabled="loading"
              variant="primary"
            >
              <Loader v-if="loading" size="small" negative />
              <template v-else>
                {{ $t('common.activate') }}
              </template>
            </Btn>
          </li>
        </ListInline>
      </Form>
    </main>
  </CDialog>
</template>

<script>
import Select from '@/components/ui/Select';
import { mapActions, mapState } from 'vuex';
import eventBus from '@/eventBus';
import Loader from '@/components/ui/Loader.vue';

export default {
  name: 'ActivateStationDialog',
  components: {
    Loader,
    Select,
  },
  data() {
    return {
      isOpen: false,
      station: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('courses', ['stations', 'courseConnectionsLocations']),
    options() {
      return Object.values(this.stations).filter(
        station =>
          !Object.values(this.courseConnectionsLocations)
            .map(ccL => ccL.sloid)
            .includes(station.sloid)
      );
    },
  },
  mounted() {
    eventBus.$on('toggleStationActivationDialog', this.handleToggle);
  },
  beforeDestroy() {
    eventBus.$off('toggleStationActivationDialog', this.handleToggle);
  },
  methods: {
    ...mapActions('courses', ['activateStation']),
    handleToggle() {
      this.isOpen = !this.isOpen;
    },
    submit() {
      this.loading = true;
      this.activateStation(this.station.sloid)
        .then(() => {
          this.isOpen = false;
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-top: 15px;
  margin-bottom: 1.5em;
}
.info-container {
  display: flex;
  margin-top: 1.5em;
  background-color: $warning-200;
  padding: 0.7em 1em 0.7em 1em;
  color: $danger-500;
  font-weight: bold;
}
.icon {
  color: $danger-500;
  flex: 0 0 24px;
  margin-top: 16px;
  margin-right: 10px;
}
</style>
